import { buildOWPricedCalendarRequest, buildRTPricedCalendarRequest, shouldRequestMonthFromApi } from "../helper/helper.js";
import { handleRequest } from "./helpers/handleRequest.js";
import { shouldDisplayOW } from "./helpers/shouldDisplayOW.js";
const ONE_WAY = 'one-way';
const ROUND_TRIP = 'round-trip';
function getPricingData({ displayMonths, flightDetails, pricePromise, variantName, executedMonths, departDate, getGraphURL, apolloClientInfo }) {
    if (shouldRequestMonthFromApi({
        displayMonths,
        executedMonths
    })) {
        let retailRequest = null;
        if (flightDetails?.tripType === ONE_WAY || shouldDisplayOW({
            departDate,
            flightDetails
        })) retailRequest = buildOWPricedCalendarRequest({
            tripDetails: flightDetails,
            displayMonths
        });
        if (flightDetails?.tripType === ROUND_TRIP && departDate) retailRequest = buildRTPricedCalendarRequest({
            tripDetails: flightDetails,
            displayMonths,
            departDate
        });
        if (!retailRequest) return Promise.resolve(null);
        return handleRequest({
            retailRequest,
            variantName,
            pricePromise,
            getGraphURL,
            apolloClientInfo
        });
    }
    return Promise.resolve(null);
}
export { getPricingData };
